import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/icon/cart-with-box-outline-blue.svg'


const _hoisted_1 = { class: "master-new-form" }
const _hoisted_2 = { class: "py-4 flex items-center justify-between gap-4 border-bottom-grey-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Informasi Kupon BBM")
], -1)
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Aktif", -1)
const _hoisted_6 = { class: "pt-4" }
const _hoisted_7 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Kategori Kupon BBM"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Pilih kategori kupon BBM apakah operasional atau pengisian PP")
], -1)
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Nama PP"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Pilih PP yang akan dilakukan pengisian BBM menggunakan kupon ini")
], -1)
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Nopol"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Pilih nopol kendaraan yang dapat menggunakan kupon BBM")
], -1)
const _hoisted_13 = { class: "invalid-feedback" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Nama Kru"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Tentukan nama kru yang bisa menggunakan kupon BBM")
], -1)
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Jenis Pembelian"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Pilih jenis pembelian kupon BBM apakah full atau literan")
], -1)
const _hoisted_17 = { class: "invalid-feedback" }
const _hoisted_18 = {
  key: 0,
  class: ""
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "mt-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-base" }, "Kode Kupon:", -1)
const _hoisted_22 = { class: "text-center text-lg font-bold" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "text-white pi pi-print mr-2" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Print Kupon")
const _hoisted_25 = {
  key: 0,
  class: "grid grid-cols-3 gap-4 mb-3"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Kapasitas Liter"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Kapasitas jumlah liter yang berlaku untuk kupon BBM")
], -1)
const _hoisted_27 = { class: "col-span-2" }
const _hoisted_28 = { class: "p-inputgroup flex-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Liter", -1)
const _hoisted_30 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_31 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Jenis BBM"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Pilih jenis BBM yang bisa diisikan dengan kupon BBM ini")
], -1)
const _hoisted_33 = { class: "col-span-2" }
const _hoisted_34 = { class: "invalid-feedback" }
const _hoisted_35 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "required font-semibold text-lg" }, "Tanggal Berlaku"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Tentukan tanggal berlaku kupon BBM")
], -1)
const _hoisted_37 = { class: "col-span-2" }
const _hoisted_38 = { class: "flex w-full" }
const _hoisted_39 = { class: "w-1/2" }
const _hoisted_40 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "px-3 flex items-center" }, " s/d ", -1)
const _hoisted_42 = { class: "w-1/2" }
const _hoisted_43 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_44 = { class: "grid grid-cols-3 gap-4 mb-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-lg" }, "Keterangan"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm" }, "Keterangan tambahan untuk kupon")
], -1)
const _hoisted_46 = { class: "col-span-2" }
const _hoisted_47 = { class: "invalid-feedback" }
const _hoisted_48 = { class: "flex items-center justify-end gap-4 mt-4" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Simpan")
const _hoisted_51 = {
  key: 0,
  class: "text-red tex-sm italic"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, /*#__PURE__*/_toDisplayString('Alasan Nonaktif Kupon'), -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, "Pengisian BBM Terakhir", -1)
const _hoisted_54 = { class: "text-base font-bold mb-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data riwayat pengisian BBM. ", -1)
const _hoisted_56 = { class: "text-center break-words text-sm" }
const _hoisted_57 = { class: "text-center break-words text-sm" }
const _hoisted_58 = { class: "text-center break-words text-sm" }
const _hoisted_59 = { class: "text-center break-words text-sm" }
const _hoisted_60 = { class: "my-6 flex justify-end" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("Kembali")

import apiUseCase from '@/usecase/apiUseCase'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import InputText from 'primevue/inputtext'
import { Field, useForm } from 'vee-validate'
import { onMounted, ref, computed, getCurrentInstance, watch, nextTick } from 'vue'
import { DatePicker } from 'v-calendar'
import { useStore } from 'vuex'
import * as Yup from 'yup'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import Button from 'primevue/button'
import moment from 'moment'
import InputNumber from 'primevue/inputnumber'
import InputSwitch from 'primevue/inputswitch'
import Card from 'primevue/card'
import { useRoute, useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import SelectAsyncOpen from '@/views/components/form/SelectAsyncOpen.vue'
import HjpDefaultModal from '@/views/components/modal/ModalDefault.vue'
import numberFormat from '@/utils/helpers/numberFormat'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import InactivePage from './components/InactivePage.vue'
import SelectAsyncRitOptions from './components/SelectAsyncRitOptions.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const fuelCouponEndpoint = '/transaction/v2/FuelTransactionVouchers'
const fuelTransactionEndpoint = '/transaction/v2/FuelingTransactions'
const vehicleEndpoint = 'management/v1/MsVehicle'
const crewEndpoint = 'management/v1/User/all-user'
const ritEndpoint = 'transaction/v1/Rit'
const employeeEndpoint = 'talent/v1/employees'

const store = useStore()
const idPrams = ref(null) as any
const app = getCurrentInstance()
const isClaimed = ref(false)
const lastUpdate = ref(null)
const isShowDialogChangeStatusForm = ref(false)
const isActive = ref<boolean>(true)
const isShowVehicleLastFuelTransactionDialog = ref(false)
const vehicleLastFuelTransactionData = ref(null) as any
const route = useRoute()
const router = useRouter()
const {
  $toast
} = app!.appContext.config.globalProperties
const qrImage = ref('')
const dataCoupon = ref(null) as any

const initialValues = ref({
  vehicle: null as any,
  crew: null as any,
  couponType: null as any,
  fuelQty: 0,
  couponCategory: null as any,
  fuelType: null as any,
  availableDate: {
    start: null as any,
    end: null as any
  },
  rit: null as any,
  note: '',
  isActive: true
})

const schema = Yup.object().shape({
  vehicle: Yup.object().required('Nopol Bus harus diisi'),
  crew: Yup.object().required('Nama Kru harus diisi'),
  couponType: Yup.object().required('Jenis Pembelian harus diisi'),
  // fuelQty: Yup.number()
  //   .required('Kapasitas Liter harus diisi')
  //   .min(0.01, 'Kapasitas Liter tidak boleh 0')
  //   .max(7, 'Kapasitas Liter maksimal 7 digit'),
  fuelQty: Yup.number().when('couponType', {
    is: (couponType: any) => couponType?.value !== 'FullTank',
    then: (schemaDetail: any) => schemaDetail
      .required('Kapasitas Liter harus diisi')
      .min(0.01, 'Kapasitas Liter tidak boleh 0')
      .max(9999999, 'Kapasitas Liter maksimal 7 digit'),
    otherwise: (schemaDetail) => schemaDetail.nullable().notRequired()
  }),
  couponCategory: Yup.object().required('Kategori Kupon harus diisi'),
  fuelType: Yup.object().required('Jenis BBM harus diisi'),
  rit: Yup.object().when('couponCategory', {
    is: (couponCategory: any) => couponCategory?.value === 'TransactionPp',
    then: (schemaDetail: any) => schemaDetail
      .required('Nama PP harus diisi'),
    otherwise: (schemaDetail) => schemaDetail.nullable().notRequired()
  }),
  availableDate: Yup.object().shape({
    start: Yup.string().required('Tanggal Berlaku harus diisi')
  }),
  // note: Yup.string()
  //   .min(3, 'Keterangan minimal 3 karakter')
  //   .max(255, 'Keterangan maksimal 255 karakter')
  //   .matches(rgxExp.notPrefixSpace, 'Keterangan tidak boleh hanya menggunakan spasi')
  //   .required('Keterangan harus diisi'),
})

const { values, errors, setFieldValue, handleSubmit, resetForm, meta } = useForm({
  initialValues,
  validationSchema: schema
})

const dateRangeText = computed(() => {
  const { start, end } = values.availableDate || {}

  if (!start || !end) return ''

  return `${moment(start).format('DD/MM/YYYY')} - ${moment(end).format('DD/MM/YYYY')}`
})

const processSubmit = async (payload: any) => {
  store.dispatch('showLoading')
  try {
    await apiUseCase.postOrPut(fuelCouponEndpoint, idPrams.value?.Id, payload).then((response) => {
      const { error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          detail: `Kupon BBM berhasil ${idPrams.value ? 'diubah' : 'disimpan'}`,
          group: 'bc',
          life: 3000
        })
        store.dispatch('setReloadDataTable')
        // eslint-disable-next-line no-use-before-define
        hideSidebar()
      } else {
        $toast.add({
          severity: 'error',
          summary: `Gagal ${idPrams.value ? 'mengubah' : 'menyimpan'} Kupon BBM`,
          detail: message,
          group: 'bc',
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: `Gagal ${idPrams.value ? 'diubah' : 'disimpan'} Kupon BBM`,
      detail: error,
      group: 'bc',
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const onSubmit = handleSubmit((dataForm: any) => {
  // console.log('onSubmit', dataForm)
  const payload = {
    StartDate: moment(dataForm.availableDate.start).format('YYYY-MM-DD'),
    EndDate: moment(dataForm.availableDate.end).format('YYYY-MM-DD'),
    Category: dataForm.couponCategory.Name ?? '-',
    FuelType: dataForm.fuelType.label ?? '-',
    FuelingType: dataForm.couponType.Name ?? '-',
    LitersQty: dataForm.fuelQty,
    VehicleId: dataForm.vehicle.Id ?? '-',
    VehicleRegNumber: dataForm.vehicle.label ?? '-',
    CrewId: dataForm.crew?.id ?? dataForm.crew?.Id,
    CrewName: dataForm.crew?.fullName ?? dataForm.crew?.CondecturName,
    // CrewRoleName: dataForm.crew?.RolesName,
    CrewRoleName: dataForm.crew?.latestEmployment ? dataForm.crew?.latestEmployment?.positionName : dataForm.crew?.RolesName,
    FuelStationPartnerId: null,
    FuelStationPartnerName: null,
    Description: dataForm.note,
    IsActive: dataForm.isActive,
    RitId: dataForm.rit?.value ?? null
  }
  processSubmit(payload)
})

const hideSidebar = () => {
  router.push({
    name: 'master-fuel-coupon'
  })
}

const getRitDetail = async (ritId: any) => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${ritEndpoint}/${ritId}`).then((response) => {
    const { result, error } = response
    // console.log('res', result)
    setFieldValue('rit', {
      dataParent: result,
      label: result.TransactionPp?.TrxId,
      value: result.Id
    })
  })
  store.dispatch('hideLoading')
}

const getDataDetail = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${fuelCouponEndpoint}/${idPrams.value?.Id}`).then((response) => {
    const { result, error } = response
    if (!error) {
      qrImage.value = `data:image/png;base64,${result.QrImage}`
      dataCoupon.value = result
      setFieldValue('couponCategory', { Name: result.Category, label: result.CategoryDisplayName, value: result.Category })
      setFieldValue('vehicle', { Id: result.VehicleId, Nopol: result.VehicleRegNumber, label: result.VehicleRegNumber, value: result.VehicleId })
      if (result.CrewId) {
        setFieldValue('crew', { Id: result.CrewId, CrewName: result.CrewName, RolesName: result.CrewRoleName, label: `${result.CrewName} - ${result.CrewRoleName ?? ''}`, value: result.CrewId })
      }
      if (result.RitId) {
        getRitDetail(result.RitId)
      }
      setFieldValue('couponType', { Name: result.FuelingType, label: result.FuelingTypeDisplayName, value: result.FuelingType })
      setFieldValue('fuelQty', result.LitersQty)
      setFieldValue('fuelType', { label: result.FuelType, value: result.FuelType })
      setFieldValue('availableDate', { start: result.StartDate, end: result.EndDate })
      if (result.Description) {
        setFieldValue('note', result.Description)
      }
      setFieldValue('isActive', result.IsActive)
      // if (!result.IsActive && idPrams.value) {
      //   isActive.value = result.IsActive
      // }
      isActive.value = !idPrams.value
      isClaimed.value = result.ClaimedAt
      lastUpdate.value = result.UpdatedAt
    }
  })
  store.dispatch('hideLoading')
}

const exportPdf = async () => {
  store.dispatch('showLoading')
  // console.log('idPrams', idPrams.value)
  await apiUseCase.getBlob(`${fuelCouponEndpoint}/${dataCoupon.value?.Id}/Export`).then((response) => {
    const { error, result } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data berhasil didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
      const blob = result
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Kupon BBM [${dataCoupon.value?.VehicleRegNumber}-${dataCoupon.value?.CrewName}] (${moment().format('DDMMYYYY')}).pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
      // closeDialog()
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Data gagal didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const copyText = async (text: any) => {
  try {
    await navigator.clipboard.writeText(text)
    $toast.add({
      severity: 'success',
      summary: 'Kode Kupon BBM Berhasil Dicopy',
      detail: 'Anda berhasil menyalin kode kupon BBM ini',
      group: 'bc',
      closable: false,
      life: 3000
    })
    // console.log('Berhasil dicopy')
  } catch (error) {
    console.error('Gagal copy:', error)
  }
}

const hideDialogChangeStatusForm = () => {
  dataCoupon.value.IsActive = !dataCoupon.value.IsActive
  isShowDialogChangeStatusForm.value = false
}

watch(
  () => values.couponCategory,
  (newValue, oldValue) => {
    if ((newValue && oldValue) || (oldValue && !newValue)) {
      setFieldValue('vehicle', null)
      setFieldValue('crew', null)
      setFieldValue('rit', null)
    }
  },
  { deep: true }
)

watch(
  () => values.rit,
  (value) => {
    // console.log('value', value)
    if (value) {
      const busData = { Id: value.dataParent?.TransactionPp?.VehicleId, Nopol: value.dataParent?.TransactionPp?.VehicleRegNumber, label: value.dataParent?.TransactionPp?.VehicleRegNumber, value: value.dataParent?.TransactionPp?.VehicleId }
      setFieldValue('vehicle', busData)
      if (!idPrams.value) {
        // eslint-disable-next-line no-use-before-define
        checkVehicleFuelTransaction(busData)
      }
      setFieldValue('crew', { Id: value.dataParent?.TransactionPp?.CondecturId, CondecturName: value.dataParent?.TransactionPp?.CondecturName, RolesName: 'Condectur', label: `${value.dataParent?.TransactionPp?.CondecturName} - Condectur`, value: value.dataParent?.TransactionPp?.CondecturId })
    } else {
      setFieldValue('vehicle', null)
      setFieldValue('crew', null)
    }
  },
  { deep: true }
)

const showVehicleLastFuelTransactionDialog = () => {
  isShowVehicleLastFuelTransactionDialog.value = true
}

const hideVehicleLastFuelTraansactionDialog = () => {
  isShowVehicleLastFuelTransactionDialog.value = false
  vehicleLastFuelTransactionData.value = null
}

const checkVehicleFuelTransaction = async (data: any) => {
  // console.log('data', data)
  if (data) {
    store.dispatch('showLoading')
    await apiUseCase.get(`${fuelTransactionEndpoint}?vehicleId=${data.Id}`).then((response) => {
      // console.log('res', response)
      const { error, result } = response
      vehicleLastFuelTransactionData.value = {
        VehicleRegNumber: data.Nopol,
        LastTransaction: result.length > 0 ? [result[0]] : null
      }
      // console.log('vehicleLastFuelTransactionData', vehicleLastFuelTransactionData.value)
      showVehicleLastFuelTransactionDialog()
    })
    store.dispatch('hideLoading')
  }
}

onMounted(() => {
  // console.log('store', store.state)
  store.dispatch('setToggleDatatableSidebarDeleteButton', false)
  let titleForm = 'Tambah'
  if (route.params.id) {
    titleForm = 'Detail'
    // idPrams.value = store.state.hjpTable.modal.data.Id
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
    // console.log('prams', idPrams.value)
    getDataDetail()
  }
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Kupon BBM',
      routeName: 'master-fuel-coupon'
    },
    {
      title: `${titleForm} Kupon BBM`,
      routeName: 'master-fuel-coupon-form',
      params: { id: route.params.id }
    }
  ])
  // store.dispatch('setTitleFormSidebar', `${titleForm} Kupon BBM`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
        class: "form-container"
      }, [
        _createVNode(_unref(Card), { lass: "card-no-shadow" }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_unref(InputSwitch), {
                  modelValue: _unref(values).isActive,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(values).isActive) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(dataCoupon)?.IsActive ? isShowDialogChangeStatusForm.value = true : '')),
                  disabled: !_unref(dataCoupon)?.IsActive
                }, null, 8, ["modelValue", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(_unref(idPrams) ? 'col-span-2' : 'col-span-3')
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["grid gap-4 mb-3", _unref(idPrams) ? 'grid-cols-2' : 'grid-cols-3'])
                  }, [
                    _hoisted_8,
                    _createElementVNode("div", {
                      class: _normalizeClass(_unref(idPrams) ? 'col-span-1' : 'col-span-2')
                    }, [
                      _createVNode(_unref(Field), { name: "couponCategory" }, {
                        default: _withCtx(() => [
                          _createVNode(SelectAsync, {
                            endpoint: `${fuelCouponEndpoint}/FuelTransactionVoucherCategories`,
                            classname: "custom-select",
                            fieldLabel: (v) => v.Description,
                            fieldValue: 'Name',
                            searchFields: ['q'],
                            placeholder: 'Pilih Kategori Kupon',
                            modelValue: _unref(values).couponCategory,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(values).couponCategory) = $event)),
                            disabled: !isActive.value,
                            inputId: "couponCategory"
                          }, null, 8, ["endpoint", "fieldLabel", "modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(errors).couponCategory), 1)
                    ], 2)
                  ], 2),
                  (_unref(values).couponCategory?.value === 'TransactionPp')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["grid gap-4 mb-3", _unref(idPrams) ? 'grid-cols-2' : 'grid-cols-3'])
                      }, [
                        _hoisted_10,
                        _createElementVNode("div", {
                          class: _normalizeClass(_unref(idPrams) ? 'col-span-1' : 'col-span-2')
                        }, [
                          _createVNode(_unref(Field), { name: "rit" }, {
                            default: _withCtx(() => [
                              _createVNode(SelectAsyncRitOptions, {
                                endpoint: `transaction/v1/Rit`,
                                classname: "custom-select",
                                fieldLabel: (v) => v.TransactionPp?.TrxId,
                                searchFields: ['q'],
                                searchCustom: [['msStatusId', '=', '7']],
                                placeholder: 'Pilih PP',
                                modelValue: _unref(values).rit,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(values).rit) = $event)),
                                disabled: !isActive.value,
                                inputId: "rit"
                              }, null, 8, ["fieldLabel", "modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(errors).rit), 1)
                        ], 2)
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["grid gap-4 mb-3", _unref(idPrams) ? 'grid-cols-2' : 'grid-cols-3'])
                  }, [
                    _hoisted_12,
                    _createElementVNode("div", {
                      class: _normalizeClass(_unref(idPrams) ? 'col-span-1' : 'col-span-2')
                    }, [
                      _createVNode(_unref(Field), { name: "vehicle" }, {
                        default: _withCtx(() => [
                          _createVNode(SelectAsync, {
                            endpoint: vehicleEndpoint,
                            inputId: "vehicle",
                            classname: "custom-select",
                            fieldLabel: (v) => v.Nopol,
                            searchFields: ['nopol'],
                            placeholder: 'Pilih Nopol Bus',
                            onChange: _cache[4] || (_cache[4] = (val) => checkVehicleFuelTransaction(val)),
                            searchCustom: [...(_unref(values).couponCategory?.value === 'Operational' ? [['vehicleCategory', '=', 'Operational']] : [])],
                            modelValue: _unref(values).vehicle,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(values).vehicle) = $event)),
                            disabled: (!_unref(values).couponCategory || _unref(values).couponCategory?.value === 'TransactionPp') || !isActive.value
                          }, null, 8, ["fieldLabel", "searchCustom", "modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(errors).vehicle), 1)
                    ], 2)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["grid gap-4 mb-3", _unref(idPrams) ? 'grid-cols-2' : 'grid-cols-3'])
                  }, [
                    _hoisted_14,
                    _createElementVNode("div", {
                      class: _normalizeClass(_unref(idPrams) ? 'col-span-1' : 'col-span-2')
                    }, [
                      _createVNode(_unref(Field), { name: "crew" }, {
                        default: _withCtx(() => [
                          _createVNode(SelectAsyncOpen, {
                            endpoint: employeeEndpoint,
                            classname: "custom-select",
                            disabled: (!_unref(values).couponCategory || _unref(values).couponCategory?.value === 'TransactionPp') || !isActive.value,
                            inputId: "crew",
                            fieldLabel: (v) => `${v.fullName} - ${v.latestEmployment?.positionName ?? 'Belum memiliki jabatan'}`,
                            searchFields: ['FullName'],
                            placeholder: 'Pilih Nama Kru',
                            modelValue: _unref(values).crew,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(values).crew) = $event)),
                            searchCustom: [['isActive', '=', 'true']]
                          }, null, 8, ["disabled", "fieldLabel", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(errors).crew), 1)
                    ], 2)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["grid gap-4 mb-3", _unref(idPrams) ? 'grid-cols-2' : 'grid-cols-3'])
                  }, [
                    _hoisted_16,
                    _createElementVNode("div", {
                      class: _normalizeClass(_unref(idPrams) ? 'col-span-1' : 'col-span-2')
                    }, [
                      _createVNode(_unref(Field), { name: "couponType" }, {
                        default: _withCtx(() => [
                          _createVNode(SelectAsync, {
                            endpoint: `${fuelCouponEndpoint}/FuelingTypes`,
                            classname: "custom-select",
                            inputId: "couponType",
                            fieldLabel: (v) => v.Description,
                            fieldValue: 'Name',
                            searchFields: ['q'],
                            placeholder: 'Pilih Jenis Kupon',
                            modelValue: _unref(values).couponType,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(values).couponType) = $event)),
                            disabled: !isActive.value
                          }, null, 8, ["endpoint", "fieldLabel", "modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(errors).couponType), 1)
                    ], 2)
                  ], 2)
                ], 2),
                (_unref(idPrams))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (qrImage.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: qrImage.value,
                            alt: "QR Code",
                            style: {"width":"200px","height":"200px"},
                            class: "border-grey-3 rounded-lg mx-auto"
                          }, null, 8, _hoisted_19))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("p", _hoisted_22, [
                          _createTextVNode(_toDisplayString(_unref(dataCoupon)?.Code ?? '-') + " ", 1),
                          _createElementVNode("i", {
                            class: "pi pi-clone text-primary cursor-pointer ml-2",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (copyText(_unref(dataCoupon)?.Code)))
                          })
                        ]),
                        _createVNode(_unref(Button), {
                          class: "btn-primary mt-3 mx-auto",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (exportPdf()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_23,
                            _hoisted_24
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_unref(values).couponType && _unref(values).couponType?.Name !== 'FullTank')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_unref(Field), { name: "fuelQty" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_unref(InputNumber), {
                              modelValue: _unref(values).fuelQty,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(values).fuelQty) = $event)),
                              class: _normalizeClass(`${_unref(errors).fuelQty ? 'input-invalid' : ''}`),
                              disabled: !isActive.value,
                              id: "fuelQty",
                              placeholder: "0",
                              min: 0,
                              locale: "id-ID",
                              step: 0.25,
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              inputId: "refund-amount"
                            }, null, 8, ["modelValue", "class", "disabled", "step"]),
                            _hoisted_29
                          ])
                        ]),
                        _: 1
                      }),
                      (_unref(meta).touched)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(errors).fuelQty), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_unref(Field), { name: "fuelType" }, {
                    default: _withCtx(() => [
                      _createVNode(SelectAsync, {
                        endpoint: `${fuelCouponEndpoint}/FuelTypes`,
                        classname: "custom-select",
                        fieldLabel: (v) => v.Name,
                        fieldValue: 'Name',
                        searchFields: ['q'],
                        placeholder: 'Pilih Jenis BBM',
                        modelValue: _unref(values).fuelType,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(values).fuelType) = $event)),
                        disabled: !isActive.value,
                        inputId: "fuelType"
                      }, null, 8, ["endpoint", "fieldLabel", "modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(errors).fuelType), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_unref(Field), { name: "availableDate" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_unref(Field), { name: "availableDate.start" }, {
                            default: _withCtx(({ field, handleChange, handleBlur }) => [
                              _createVNode(_unref(DatePicker), _mergeProps(field, {
                                masks: {
                          input: 'DD/MM/YYYY'
                        },
                                minDate: new Date,
                                maxDate: _unref(values).availableDate.end ? new Date(new Date(_unref(values).availableDate.end).setDate(new Date(_unref(values).availableDate.end).getDate() - 1)) : null
                              }), {
                                default: _withCtx(({ togglePopover }) => [
                                  _createVNode(_unref(InputText), {
                                    id: "start-date",
                                    placeholder: "Masukkan tanggal mulai",
                                    readonly: true,
                                    disabled: !isActive.value,
                                    value: _unref(values).availableDate.start ? `${_unref(moment)(_unref(values).availableDate.start.toString()).format('DD/MM/YYYY')}` : _unref(values).availableDate.start,
                                    class: _normalizeClass(`input-default`),
                                    onClick: togglePopover
                                  }, null, 8, ["disabled", "value", "onClick"])
                                ]),
                                _: 2
                              }, 1040, ["maxDate"])
                            ]),
                            _: 1
                          }),
                          (_unref(meta).touched)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref(errors)['availableDate.start']), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_41,
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_unref(Field), { name: "availableDate.end" }, {
                            default: _withCtx(({ field, handleChange, handleBlur }) => [
                              _createVNode(_unref(DatePicker), _mergeProps(field, {
                                masks: {
                          input: 'DD/MM/YYYY'
                        },
                                minDate: new Date(new Date(_unref(values).availableDate.start).setDate(new Date(_unref(values).availableDate.start).getDate() + 1))
                              }), {
                                default: _withCtx(({ togglePopover }) => [
                                  _createVNode(_unref(InputText), {
                                    id: "end-date",
                                    placeholder: "Masukkan tanggal akhir",
                                    readonly: true,
                                    value: _unref(values).availableDate.end ? `${_unref(moment)(_unref(values).availableDate.end.toString()).format('DD/MM/YYYY')}` : _unref(values).availableDate.end,
                                    class: _normalizeClass(`input-default`),
                                    onClick: togglePopover,
                                    disabled: !_unref(values).availableDate.start || !isActive.value
                                  }, null, 8, ["value", "onClick", "disabled"])
                                ]),
                                _: 2
                              }, 1040, ["minDate"])
                            ]),
                            _: 1
                          }),
                          (_unref(meta).touched)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(errors)['availableDate.end']), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_unref(Field), {
                    name: "note",
                    as: "textarea",
                    rows: "5",
                    cols: "30",
                    maxlength: 255,
                    placeholder: "Tulis keterangan",
                    disabled: !isActive.value,
                    class: "",
                    id: "note"
                  }, null, 8, ["disabled"]),
                  _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(errors).note), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (hideSidebar()))
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              }),
              (!_unref(idPrams))
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    type: "submit",
                    class: "btn-primary mr-1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_50
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (_unref(dataCoupon) && !_unref(dataCoupon)?.IsActive)
              ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(`Kupon telah ${isClaimed.value ? 'digunakan' : !isClaimed.value && !_unref(dataCoupon)?.IsActive ? 'dinonaktifkan' : ''} pada tanggal ${lastUpdate.value ? _unref(moment)(lastUpdate.value).format('DD MMMM YYYY HH:mm:ss') : ''}`), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 32)
    ]),
    _createVNode(HjpDefaultModal, {
      show: isShowDialogChangeStatusForm.value,
      onHideDialog: hideDialogChangeStatusForm,
      hasTitle: true
    }, {
      title: _withCtx(() => [
        _hoisted_52
      ]),
      content: _withCtx(() => [
        _createVNode(InactivePage, {
          onHideDialog: _cache[14] || (_cache[14] = ($event: any) => (hideDialogChangeStatusForm())),
          data: _unref(dataCoupon)
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show"]),
    (isShowVehicleLastFuelTransactionDialog.value)
      ? (_openBlock(), _createBlock(HjpDefaultModal, {
          key: 0,
          show: isShowVehicleLastFuelTransactionDialog.value,
          onHideDialog: hideVehicleLastFuelTraansactionDialog,
          hasTitle: true
        }, {
          title: _withCtx(() => [
            _hoisted_53
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_54, "Nopol: " + _toDisplayString(_unref(vehicleLastFuelTransactionData)?.VehicleRegNumber ?? '-'), 1),
            (isShowVehicleLastFuelTransactionDialog.value)
              ? (_openBlock(), _createBlock(_unref(DataTable), {
                  key: 0,
                  value: _unref(vehicleLastFuelTransactionData)?.LastTransaction,
                  class: "w-full"
                }, {
                  empty: _withCtx(() => [
                    _hoisted_55
                  ]),
                  loading: _withCtx(() => [
                    _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(Column), { header: "TANGGAL" }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("p", _hoisted_56, _toDisplayString(data?.CreatedAt ? _unref(moment)().format('DD/MM/YYYY HH:mm:ss') : '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), { header: "POM MITRA" }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("p", _hoisted_57, _toDisplayString(data.FuelStationPartnerName ?? '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), { header: "PEMBELIAN" }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("p", _hoisted_58, _toDisplayString(`${_unref(numberFormat)(data.Liters ?? 0)} L`), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), { header: "JENIS" }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("p", _hoisted_59, _toDisplayString(data.TransactionType === 'Voucher' ? 'Kupon BBM' : data.TransactionType === 'Refund' ? 'Refund' : 'Scan Aplikasi'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_60, [
              _createVNode(_unref(Button), {
                class: "btn-back",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (hideVehicleLastFuelTraansactionDialog()))
              }, {
                default: _withCtx(() => [
                  _hoisted_61
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})